import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'

// A hash map of metrics id => data
const defaultState = {}

export const metrics = function(state = defaultState, action) {
  switch (action.type) {
    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS: {
      return {
        ...state,
        ...(() => {
          var metrics = {}
          action.result.data.campaign.metrics.nodes.forEach(node => {
            metrics[node.id] = Object.assign({}, state[node.id], node)
          })
          return metrics
        })(),
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Metric/reducer.js